var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLink',{staticClass:"item",attrs:{"ga-event":_vm.gaEvent,"to":_vm.routeTo}},[_c('div',{staticClass:"item__icon"},[_c(_vm.icon,{tag:"component"})],1),_c('div',{staticClass:"item__text"},[_vm._v(_vm._s(_vm.item.search_result_title))])])}
var staticRenderFns = []

export { render, staticRenderFns }